<script lang="ts">
  import { dataFieldMap, type SubcatInputConfig } from '$src/types/dataFieldWrapper';
  import type { PostFiltersSchema } from '$src/utils/api/feed.util';

  export const isValid: boolean = true;
  export let inputConfig: SubcatInputConfig;
  export let detail: PostFiltersSchema['dynamicFilters'][string] | unknown = '';

  function onChange(e: CustomEvent<{ value: string; label: string }>) {
    detail = e.detail.value;
  }
</script>

<svelte:component
  this={dataFieldMap[inputConfig.component]}
  {...inputConfig.props}
  on:change={onChange}
  on:delete
  value={detail}
/>
